import type { PageField } from '~/pages/AskRichardUnified/page/pageContract';
import { validatePageFilters } from '~/pages/AskRichardUnified/page/pageFilters';

import { NONE_FILTER_VALUE } from './filterSelection';

export const RM_EDITABLE_FIELDS: Record<string, PageField> = {
  view: { type: 'enum', values: ['monitor', 'detail'] },
  range: { type: 'enum', values: ['quarter', 'custom'] },
  from: { type: 'date' },
  to: { type: 'date' },
  itemStatuses: { type: 'enum', multiple: true, values: ['', 'None', 'awaiting_dates', 'cancelled', 'completed'] },
};

const queryKeys: Record<string, string> = { view: 'rm_view', range: 'rm_range', from: 'rm_from', to: 'rm_to' };

/** A page-chat edit is a patch: preserve every filter or date the request did not change. */
export function rmPageEditSearch(search: string, changes: Record<string, unknown>): string {
  validatePageFilters(changes, RM_EDITABLE_FIELDS);
  const next = new URLSearchParams(search);
  for (const [key, value] of Object.entries(changes)) {
    if (key === 'itemStatuses') {
      next.delete('rm_status');
      next.delete('rm_status_all');
      const statuses = [...new Set(String(value).split(',').map((status) => status.trim()).filter(Boolean))];
      if (statuses.includes('None') && statuses.length > 1) throw new Error('Select None separately from named item statuses.');
      if (!statuses.length) next.set('rm_status_all', '1');
      statuses.forEach((status) => next.append('rm_status', status === 'None' ? NONE_FILTER_VALUE : status));
    } else {
      next.set(queryKeys[key], String(value));
    }
  }
  if ((changes.from || changes.to) && next.get('rm_range') !== 'custom') {
    throw new Error('Set range to custom when editing dates.');
  }
  if (next.get('rm_range') === 'custom' && (!next.get('rm_from') || !next.get('rm_to') || next.get('rm_from')! > next.get('rm_to')!)) {
    throw new Error('Custom range requires valid from and to dates in order.');
  }
  return next.toString();
}
